import React, { useEffect, useState, useRef } from "react";
import "../style.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { icon } from "@fortawesome/fontawesome-svg-core/import.macro";
import {
  getAuth,
  sendPasswordResetEmail,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
} from "firebase/auth";
import { collection, query, where, getDocs, addDoc } from "firebase/firestore";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db, storage } from "../firebase/firebase";
import styles from "../styles/Services.module.scss";

function Home({
  showPopup,
  setShowPopup,
  showContactMessage,
  setShowContactMessage,
  popupSource,
  setPopupSource,
}) {
  // State for letter animation
  const [visibleLetters, setVisibleLetters] = useState(0);
  const headingText = "Für Trainer, die mehr bewegen wollen.";
  const subtitleText =
    "Verwalte Trainingspläne, Fortschritte und Kunden an einem Ort.";

  // Left-to-right reveal animation
  const [isRevealed, setIsRevealed] = useState(false);
  const [firstButtonRevealed, setFirstButtonRevealed] = useState(false);
  const [secondButtonRevealed, setSecondButtonRevealed] = useState(false);

  useEffect(() => {
    // Start animation after component mounts
    const titleTimer = setTimeout(() => {
      setIsRevealed(true);

      // Start first button animation after title animation (0.8s + 0.2s delay)
      const firstButtonTimer = setTimeout(() => {
        setFirstButtonRevealed(true);

        // Start second button animation 300ms after first button
        const secondButtonTimer = setTimeout(() => {
          setSecondButtonRevealed(true);
        }, 300);

        return () => clearTimeout(secondButtonTimer);
      }, 1000);

      return () => clearTimeout(firstButtonTimer);
    }, 50);

    return () => clearTimeout(titleTimer);
  }, []);

  // Ref for the video element
  const videoRef = useRef(null);
  const videoRef2 = useRef(null);
  const heroVideoRef = useRef(null);

  // Refs for sections
  const about1LeftRef = useRef(null);
  const about1RightRef = useRef(null);
  const about2LeftRef = useRef(null);
  const about2RightRef = useRef(null);
  const about3LeftRef = useRef(null);
  const about3RightRef = useRef(null);
  const aboutTitleRef = useRef(null);
  const aboutParagraphRef = useRef(null);
  const infoSectionsRef = useRef([]);

  // Refs for the card boxes
  const cardRefs = useRef([]);
  cardRefs.current = [];

  // Function to add elements to the cardRefs array
  const addToCardRefs = (el) => {
    if (el && !cardRefs.current.includes(el)) {
      cardRefs.current.push(el);
    }
  };

  // Handle card animations on scroll
  useEffect(() => {
    // Animation for card entries with staggered delay
    const cardObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry, index) => {
          if (entry.isIntersecting) {
            // Staggered animation with delay based on index
            setTimeout(() => {
              entry.target.style.opacity = 1;
              entry.target.style.transform = "translateY(0)";
            }, index * 200); // 200ms delay between each card
            cardObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1, rootMargin: "0px 0px -50px 0px" }
    );

    // Observe all card elements
    cardRefs.current.forEach((card) => {
      cardObserver.observe(card);
    });

    // Cleanup function
    return () => {
      cardRefs.current.forEach((card) => {
        if (card) cardObserver.unobserve(card);
      });
    };
  }, []);

  // Ref for contact form message
  const messageRef = useRef(null);

  // Contact form state
  const [contactFormData, setContactFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isFormSubmitting, setIsFormSubmitting] = useState(false);
  const [formSubmitStatus, setFormSubmitStatus] = useState({
    success: false,
    message: "",
  });

  // popupSource is now coming from props

  // Handle form submission to Firebase
  const handleContactFormSubmit = async () => {
    // Validate form data

    console.log("contactFormData");
    console.log(contactFormData);
    if (
      !contactFormData.name ||
      !contactFormData.email ||
      !contactFormData.subject ||
      !contactFormData.message
    ) {
      setFormSubmitStatus({
        success: false,
        message: "Bitte füllen Sie alle Felder aus.",
      });
      return;
    }

    // Start submission process
    setIsFormSubmitting(true);
    setFormSubmitStatus({ success: false, message: "" });

    try {
      // Add timestamp to the data
      const submissionData = {
        ...contactFormData,
        timestamp: new Date(),
      };

      console.log(submissionData);

      const messageText = String(contactFormData.message);

      // contactMessages allows only name, email and message
      const contactMessage = {
        name: contactFormData.name,
        email: contactFormData.email,
        message: messageText,
      };

      // mail allows only to and message.subject / message.text
      var mailData = {
        to: "elev8ionhelp@gmail.com",
        message: {
          subject: `Neue Kontaktanfrage: ${contactFormData.subject}`,
          text: `Name: ${contactFormData.name}\nEmail: ${contactFormData.email}\n\nNachricht:\n${messageText}`,
        },
      };

      // Save the contact data to Firestore for record-keeping
      const contactDocRef = await addDoc(
        collection(db, "contactMessages"),
        contactMessage
      );

      // Save the email data to the mail collection for sending
      const mailDocRef = await addDoc(collection(db, "mail"), mailData);

      console.log("Contact document written with ID: ", contactDocRef.id);
      console.log("Mail document written with ID: ", mailDocRef.id);

      // Reset form
      setContactFormData({
        name: "",
        email: "",
        subject: "",
        message: "",
      });

      // Show success message
      setFormSubmitStatus({
        success: true,
        message:
          "Vielen Dank für Ihre Nachricht! Wir werden Sie schnellstmöglich kontaktieren.",
      });
    } catch (error) {
      console.error("Error adding document: ", error);
      setFormSubmitStatus({
        success: false,
        message:
          "Es gab ein Problem beim Senden Ihrer Nachricht. Bitte versuchen Sie es später erneut.",
      });
    } finally {
      setIsFormSubmitting(false);
    }
  };

  // State to track visibility
  const [isVisible, setIsVisible] = useState({
    aboutTitle: false,
    aboutParagraph: false,
    infoSections: [false, false, false],
    about2Text: false,
    about3Text: false,
  });

  // Autoplay video when it scrolls into view
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    };
    const observer = new window.IntersectionObserver(handleIntersection, {
      threshold: 0.25,
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  // Autoplay video when it scrolls into view
  useEffect(() => {
    const video = videoRef2.current;
    if (!video) return;
    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          video.play();
        } else {
          video.pause();
        }
      });
    };
    const observer = new window.IntersectionObserver(handleIntersection, {
      threshold: 0.25,
    });
    observer.observe(video);
    return () => observer.disconnect();
  }, []);

  // Handle intersection observer for fade animations
  useEffect(() => {
    const elements = [
      { ref: aboutTitleRef, key: "aboutTitle" },
      { ref: aboutParagraphRef, key: "aboutParagraph" },
      ...infoSectionsRef.current.map((ref, index) => ({
        ref: { current: ref },
        key: `infoSection-${index}`,
      })),
      { ref: about1LeftRef, key: "about1Left" },
      { ref: about1RightRef, key: "about1Right" },
      { ref: about2LeftRef, key: "about2Left" },
      { ref: about2RightRef, key: "about2Right" },
      { ref: about3LeftRef, key: "about3Left" },
      { ref: about3RightRef, key: "about3Right" },
    ];

    const handleIntersection = (entries) => {
      entries.forEach((entry) => {
        const elementKey = entry.target.getAttribute("data-key");
        if (!elementKey) return;

        if (entry.isIntersecting) {
          setIsVisible((prev) => {
            if (elementKey.startsWith("infoSection-")) {
              const index = parseInt(elementKey.split("-")[1]);
              const newInfoSections = [...prev.infoSections];
              newInfoSections[index] = true;
              return { ...prev, infoSections: newInfoSections };
            } else if (elementKey === "about2Right") {
              // When the right container of about-2 is visible, also set about2Text to true
              return { ...prev, about2Text: true, [elementKey]: true };
            } else if (elementKey === "about3Left") {
              // When the left container of about-3 is visible, also set about3Text to true
              return { ...prev, about3Text: true, [elementKey]: true };
            }
            return { ...prev, [elementKey]: true };
          });
        }
      });
    };

    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.1,
      rootMargin: "0px 0px -20px 0px",
    });

    elements.forEach(({ ref, key }) => {
      if (ref.current) {
        ref.current.setAttribute("data-key", key);
        observer.observe(ref.current);
      }
    });

    return () => observer.disconnect();
  }, []);

  // Handle login modal toggle
  useEffect(() => {
    // const loginButton = document.querySelector(".btn-login3");
    const loginClose = document.querySelector(".modal-login-close");
    const loginModal = document.querySelector(".login-modal-wrap");
    const forgotPassword = document.querySelector(".btn-login-forgot");

    const toggleModal = (e) => {
      if (e) e.preventDefault();
      if (loginModal) {
        loginModal.classList.toggle("display-none");
      }
    };

    const handleForgotPassword = (e) => {
      e.preventDefault();
      alert("Bitte kontaktieren Sie den Support.");
      if (loginModal) {
        loginModal.classList.add("display-none");
      }
    };

    // if (loginButton) loginButton.addEventListener("click", toggleModal);
    if (loginClose) loginClose.addEventListener("click", toggleModal);
    if (forgotPassword)
      forgotPassword.addEventListener("click", handleForgotPassword);

    return () => {
      // if (loginButton) loginButton.removeEventListener("click", toggleModal);
      if (loginClose) loginClose.removeEventListener("click", toggleModal);
      if (forgotPassword)
        forgotPassword.removeEventListener("click", handleForgotPassword);
    };
  }, []);

  useEffect(() => {
    const forgot = document.querySelector(".btn-login-forgot");
    const loginClose = document.querySelector(".modal-login-close");
    const loginModal = document.querySelector(".login-modal-wrap");
    const email = document.querySelector(".login-mail");
    const password = document.querySelector(".login-password");
    const loginFirebase = document.querySelector(".modal-login");

    if (!loginClose || !forgot || !loginModal || !email || !password) return;

    loginClose.addEventListener("click", () => {
      loginModal.classList.toggle("display-none");
    });

    forgot.addEventListener("click", () => {
      const auth = getAuth();
      sendPasswordResetEmail(auth, email.value)
        .then(() => {
          alert("E-Mail zur Zurücksetzung versendet.");

          // Password reset email sent!
          // ..
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;
          alert(errorMessage);
          // ..
        });
    });

    const loginEmailPassword = async () => {
      const loginEmail = email.value;
      const loginPassword = password.value;

      const auth = getAuth();

      //todo check if user with same mail has permission first

      signInWithEmailAndPassword(auth, loginEmail, loginPassword)
        .then((userCredential) => {
          //todo check for role

          const user = userCredential.user;

          loadPermission(user.uid);
        })
        .catch((error) => {
          const errorCode = error.code;
          const errorMessage = error.message;

          if (errorCode == "auth/user-not-found") {
            alert("Benutzer nicht gefunden.");
          } else {
            alert(errorMessage);
          }
        });
    };

    const loadPermission = async (urlVar) => {
      const q = query(collection(db, "users"), where("__name__", "==", urlVar));

      const querySnapshot = await getDocs(q);

      querySnapshot.forEach((doc) => {
        if (doc.data().isTrainer) {
          window.location.replace("home/plans");
        } else {
          logout();
          alert("Keine Berechtigung.");
        }
      });
    };

    function logout() {
      const auth = getAuth();
      signOut(auth)
        .then(() => {
          // window.location.replace("/");
        })
        .catch((error) => {
          alert(error);
        });
    }

    if (loginFirebase) {
      loginFirebase.addEventListener("click", loginEmailPassword);
    }
  }, []);

  const [showCornerBanner, setShowCornerBanner] = useState(true);
  const [appearing, setAppearing] = useState(false);
  const [bannerClosing, setBannerClosing] = useState(false);
  // Popup state is now managed by App component

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50 && !showCornerBanner) {
        setShowCornerBanner(true);
        setAppearing(true);
        setTimeout(() => setAppearing(false), 400); // match animation duration
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [showCornerBanner]);

  const handleCloseBanner = () => {
    setBannerClosing(true);
    setTimeout(() => setShowCornerBanner(false), 400); // match animation duration
  };

  const handleOptionClick = () => {
    setShowContactMessage(true);
  };

  return (
    <main>
      {/* Corner Banner: bottom left */}
      {showCornerBanner && !showPopup && (
        <div
          className={`corner-banner${appearing ? " appearing" : ""}${
            bannerClosing ? " closing" : ""
          }`}
        >
          <a
            href="#"
            className="corner-banner-link"
            onClick={(e) => {
              e.preventDefault();
              setPopupSource("surprise");
              setShowPopup(true);
            }}
          >
            {"Eine Überraschung wartet auf dich!"}
          </a>
          <i
            onClick={handleCloseBanner}
            className="corner-banner-close"
            aria-label="Banner schließen"
            tabIndex={0}
            role="button"
          >
            <FontAwesomeIcon icon={icon({ name: "close", style: "solid" })} />
          </i>
        </div>
      )}

      {/* Popup */}
      {showPopup && (
        <div
          className="popup-overlay"
          onClick={() => {
            setShowPopup(false);
            setShowContactMessage(false);
          }}
        >
          <div className="popup-content" onClick={(e) => e.stopPropagation()}>
            {!showContactMessage ? (
              <>
                <h3>Was ist Ihr größtes Ziel?</h3>
                <div className="popup-options">
                  {[
                    "Klient:innen gewinnen",
                    "Prozesse vereinfachen",
                    "Klient:innen binden",
                    "Etwas Anderes",
                  ].map((option, index) => (
                    <button
                      key={index}
                      className="popup-option"
                      onClick={handleOptionClick}
                    >
                      {option}
                    </button>
                  ))}
                </div>
              </>
            ) : (
              <div className="contact-message">
                <div className="popup-intro">
                  {popupSource === "discover" ? (
                    <>
                    
                      <h3 className="popup-intro__title">
                        Werden Sie Pilotpartner
                      </h3>
                      <p className="popup-intro__lead">
                        Wir suchen aktuell{" "}
                       3 Partner, die Elev8ion kostenlos testen und aktiv mitgestalten
                        möchten.
                      </p>
                      <p className="popup-intro__cta">
                        Kontaktieren Sie uns jetzt für eine unverbindliche
                        Beratung.
                      </p>
                    </>
                  ) : (
                    <>
                      <h3 className="popup-intro__title">Gerne helfen wir Ihnen!</h3>
                      <p className="popup-intro__lead">
                        Kontaktieren Sie uns jetzt und erhalten Sie eine
                        unverbindliche und kostenlose Beratung.
                      </p>
                    </>
                  )}
                  {popupSource === "discover" ? (
                    <ul className="popup-benefits">
                      {[
                        {
                          title: "Kostenlos testen",
                          detail: "Bis zum Rollout oder mindestens 6 Monate",
                        },
                        {
                          title: "Persönliches Onboarding",
                          detail: "Individuelle Einführung in die Plattform",
                        },
                        {
                          title: "Direkter Einfluss",
                          detail: "Gestalten Sie die Entwicklung aktiv mit",
                        },
                      ].map((item) => (
                        <li key={item.title} className="popup-benefits__item">
                          <span className="popup-benefits__icon">
                            <FontAwesomeIcon
                              icon={icon({ name: "circle-check", style: "solid" })}
                            />
                          </span>
                          <span className="popup-benefits__text">
                            <strong>{item.title}</strong>
                            <span>{item.detail}</span>
                          </span>
                        </li>
                      ))}
                    </ul>
                  ) : popupSource === "surprise" ? (
                    <div className="popup-promo">
                      <p>
                        Fügen Sie Code{" "}
                        <span className="popup-promo__code">SURPRISE</span> Ihrer
                        Anfrage hinzu und erhalten Sie eine{" "}
                        <strong>verlängerte Testphase!</strong>
                      </p>
                    </div>
                  ) : null}
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "12px",
                    marginTop: "20px",
                  }}
                >
                  <button
                    className="close-button"
                    onClick={() => {
                      setShowPopup(false);
                      setShowContactMessage(false);

                      if (popupSource === "surprise") {
                        setContactFormData({
                          ...contactFormData,
                          subject: "CODE: SURPRISE",
                        });
                      }
                      if (popupSource === "discover") {
                        setContactFormData({
                          ...contactFormData,
                          subject: "Anfrage als Pilotpartner:in",
                        });
                      }

                      // Scroll to the contact section
                      const contactSection = document.getElementById("support");
                      if (contactSection) {
                        contactSection.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    Anfrage absenden
                  </button>
                  <button
                    className="back-button"
                    onClick={() => {
                      setShowPopup(false);
                      setShowContactMessage(false);
                    }}
                    style={{
                      background: "none",
                      border: "none",
                      color: "#fff",
                      textDecoration: "underline",
                      cursor: "pointer",
                      padding: "5px 10px",
                      fontSize: "14px",
                      alignSelf: "center",
                    }}
                  >
                    Zurück zur Übersicht
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Login Modal */}
      <div className="login-modal-wrap display-none">
        <div className="modal">
          <h3>Anmeldung</h3>
          <img src={require("../img/login.svg").default} alt="" />

          <form className="contact-form">
            <input type="email" className="login-mail" placeholder="E-Mail" />
            <input
              type="password"
              className="login-password"
              placeholder="Passwort"
            />
          </form>
          <button
            style={{ textDecoration: "underline", cursor: "pointer" }}
            className="btn-login-forgot"
          >
            Passwort vergessen?
          </button>

          <button className="btn modal-login">Anmelden</button>
          <button
            style={{ marginLeft: "5px" }}
            className="btn modal-login-close btn-login-light"
            onClick={(e) => {
              e.preventDefault();
              const loginModal = document.querySelector(".login-modal-wrap");
              if (loginModal) {
                loginModal.classList.add("display-none");
              }
            }}
          >
            Abbrechen
          </button>
        </div>
      </div>
      {/* Header Section */}
      <section className="hero" id="hero">
        <div style={{ backgroundColor: "#000" }} className="video-background">
          <video
            ref={heroVideoRef}
            autoPlay
            loop
            muted
            playsInline
            preload="auto"
            poster="/videos/1.png"
            style={{
              opacity: 0,
              transition: "opacity 2s ease-in-out",
              backgroundColor: "#000",
            }}
            onCanPlay={() => {
              if (heroVideoRef.current) {
                // Add a 1-second delay before starting the fade-in
                setTimeout(() => {
                  heroVideoRef.current.style.opacity = 1;
                }, 500);
              }
            }}
          >
            <source src="/videos/hero-video.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="video-overlay"></div>
        </div>
        <div className="container flex-row">
          <div style={{ width: "100%" }} className="left">
            <div
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "flex-start",
                marginBottom: "1.25rem",
                minHeight: "4.2rem",
                alignItems: "center",
                position: "relative",
              }}
            >
              <h1
                style={{
                  fontSize: "clamp(1.8rem, 6vw, 2.8rem)",
                  fontWeight: 700,
                  lineHeight: 1.2,
                  color: "#fff",
                  textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                  margin: 0,
                  textAlign: "left",
                  position: "relative",
                  overflow: "hidden",
                  maxWidth: "100%",
                }}
              >
                <div
                  style={{
                    display: "inline-block",
                    transform: isRevealed
                      ? "translateX(0)"
                      : "translateX(-100%)",
                    transition: "transform 0.8s cubic-bezier(0.22, 1, 0.36, 1)",
                  }}
                >
                  {headingText}
                </div>
              </h1>
            </div>
            <p
              style={{
                color: "rgba(255, 255, 255, 0.9)",
                fontSize: "clamp(1rem, 3vw, 1.15rem)",
                fontWeight: 400,
                lineHeight: 1.5,
                textAlign: "left",
                maxWidth: "640px",
                margin: "0 0 1.5rem",
                padding: 0,
                opacity: firstButtonRevealed ? 1 : 0,
                transform: firstButtonRevealed
                  ? "translateY(0)"
                  : "translateY(12px)",
                transition: "opacity 0.7s ease, transform 0.7s ease",
              }}
            >
              {subtitleText}
            </p>
            <div className="buttons">
              <a
                href="#start"
                style={{
                  marginBottom: "3px",
                  opacity: firstButtonRevealed ? 1 : 0,
                  transform: firstButtonRevealed
                    ? "translateY(0)"
                    : "translateY(20px)",
                  transition: "opacity 0.7s ease, transform 0.7s ease",
                  display: "inline-block",
                }}
                className="btn btn-register"
                onClick={(e) => {
                  e.preventDefault();
                  const element = document.getElementById("start");
                  if (element) {
                    const headerOffset = 70; // Adjust this value based on your header height
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition =
                      elementPosition + window.pageYOffset - headerOffset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: "smooth",
                    });
                  }
                }}
              >
                Mehr erfahren
              </a>
              <a
                href="#support"
                className="btn btn-light"
                style={{
                  opacity: secondButtonRevealed ? 1 : 0,
                  transform: secondButtonRevealed
                    ? "translateY(0)"
                    : "translateY(20px)",
                  transition: "opacity 0.7s ease, transform 0.7s ease",
                  display: "inline-block",
                }}
              >
                Kontakt
              </a>
            </div>
          </div>
          {/* <img src={require("../img/intro-img.svg").default} alt="" /> */}
        </div>
      </section>

      <section
        style={{ paddingTop: "0px" }}
        id="start"
        className="about about-1"
      >
        {/* About Us */}
        <h3
          ref={aboutTitleRef}
          style={{
            fontSize: "2rem",
            fontWeight: 700,
            // marginBottom: "1.5rem",
            color: "#1a202c",
            lineHeight: 1.3,
            position: "relative",
            paddingBottom: "1rem",
            textAlign: "center",
            marginTop: "40px",
          }}
          className={`fade-in ${isVisible.aboutTitle ? "visible" : ""}`}
          // style={{ textAlign: "center", marginTop: 30 }}
        >
          Einfache Anbindung
        </h3>
        <div className="container">
          <div className="flex-row">
            <div className="left fade-hidden" ref={about1LeftRef}>
              <p
                style={{
                  fontSize: "18px",
                  marginBottom: "10px",
                  marginTop: "10px",
                }}
                ref={aboutParagraphRef}
                className={`fade-in ${
                  isVisible.aboutParagraph ? "visible" : ""
                }`}
              >
                Mit <strong style={{ fontWeight: "700" }}>ELEV8ION</strong>{" "}
                können Sie Trainingspläne effizient erstellen, Ihre Kunden
                gezielt betreuen und den Trainingsfortschritt digital verfolgen
                – alles in einem.
              </p>
              <div
                ref={(el) => (infoSectionsRef.current[0] = el)}
                className={`flex-row fade-in ${
                  isVisible.infoSections[0] ? "visible" : ""
                }`}
              >
                <i className="fa-solid fa-person-running">
                  <FontAwesomeIcon
                    icon={icon({ name: "mobile-screen", style: "solid" })}
                  />
                </i>
                <div
                  className={`info fade-in ${
                    isVisible.infoSections[0] ? "visible" : ""
                  }`}
                >
                  <h4>App installieren</h4>
                  <p>
                    Der Kunde installiert die{" "}
                    <strong style={{ fontWeight: "700" }}>ELEV8ION App</strong>{" "}
                    auf seinem Handy und meldet sich mit wenigen Klicks an. So
                    schaffen Sie in kürzester Zeit eine direkte Verbindung.
                  </p>
                </div>
              </div>
              <div
                ref={(el) => (infoSectionsRef.current[1] = el)}
                className={`flex-row fade-in ${
                  isVisible.infoSections[1] ? "visible" : ""
                }`}
              >
                <i className="fa-regular fa-calendar">
                  <FontAwesomeIcon
                    icon={icon({ name: "calendar", style: "regular" })}
                  />
                </i>
                <div
                  ref={(el) => (infoSectionsRef.current[1] = el)}
                  className={`info fade-in ${
                    isVisible.infoSections[1] ? "visible" : ""
                  }`}
                >
                  <h4>Trainingsplan erstellen und zuweisen</h4>
                  <p>
                    Erstellen Sie individuelle Trainingspläne ganz einfach über
                    unser{" "}
                    <strong style={{ fontWeight: "700" }}>
                      intuitives Webportal
                    </strong>
                    . Mit nur wenigen Klicks können Sie neue Pläne gestalten
                    oder auf bewährte Vorlagen zurückgreifen.
                  </p>
                </div>
              </div>
              <div
                ref={(el) => (infoSectionsRef.current[2] = el)}
                className={`flex-row fade-in ${
                  isVisible.infoSections[2] ? "visible" : ""
                }`}
              >
                <i className="fa-regular fa-clipboard">
                  <FontAwesomeIcon
                    icon={icon({ name: "clipboard", style: "regular" })}
                  />
                </i>
                <div
                  ref={(el) => (infoSectionsRef.current[2] = el)}
                  className={`info fade-in ${
                    isVisible.infoSections[2] ? "visible" : ""
                  }`}
                >
                  <h4>Plan verfolgen</h4>
                  <p>
                    Verfolgen Sie den{" "}
                    <strong style={{ fontWeight: "700" }}>
                      Trainingsfortschritt in Echtzeit
                    </strong>
                    , erhalten Sie direktes Feedback vom Kunden und reagieren
                    Sie flexibel auf Veränderungen.
                  </p>
                </div>
              </div>
            </div>
            <div
              className="right floating-image"
              ref={about1RightRef}
              style={{ filter: "drop-shadow(0 10px 15px rgba(0,0,0,0.85))" }}
            >
              <img src={require("../img/about-img.svg").default} alt="" />
            </div>
          </div>
        </div>
      </section>

      {/* Video Section */}
      <section className="video-section">
        <div className="video-background">
          <video
            ref={videoRef}
            className="all-video"
            src="/videos/all.mp4"
            muted
            playsInline
            style={{
              width: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
      </section>

      <section style={{}} className="about about-2">
        <div className="container flex-row">
          <div className="left fade-hidden" ref={about2LeftRef}>
            <div className="floating-image">
              <img
                style={{ maxHeight: "300px" }}
                src={require("../img/about-extra-1.svg").default}
                alt=""
              />
            </div>
          </div>
          <div className="right fade-hidden" ref={about2RightRef}>
            <h3
              className={
                isVisible.about2Text ? "fade-in-up visible" : "fade-in-up"
              }
            >
              Personalisierte Trainingsläne
            </h3>
            <p
              className={
                isVisible.about2Text ? "fade-in-up visible" : "fade-in-up"
              }
              style={{ transitionDelay: "0.1s" }}
            >
              Erstellen Sie individuelle Trainingspläne, die perfekt auf die
              Ziele, Fähigkeiten und Bedürfnisse Ihrer Klient:innen abgestimmt
              sind. Ob Reha, Leistungssteigerung oder Alltagstauglichkeit.
            </p>
            <p
              className={
                isVisible.about2Text ? "fade-in-up visible" : "fade-in-up"
              }
              style={{ transitionDelay: "0.2s" }}
            >
              Sie definieren die Inhalte, passen sie flexibel an und verfolgen
              den Fortschritt in Echtzeit. So wird Training nicht nur
              effektiver, sondern auch messbar erfolgreicher.
            </p>
          </div>
        </div>
      </section>
      <section
        style={{ paddingBottom: "10px", paddingTop: "20px" }}
        className="about about-3"
      >
        <div className="container flex-row">
          <div className="left fade-hidden" ref={about3LeftRef}>
            <h3
              className={
                isVisible.about3Text ? "fade-in-up visible" : "fade-in-up"
              }
            >
              Skalierbar
            </h3>
            <p
              className={
                isVisible.about3Text ? "fade-in-up visible" : "fade-in-up"
              }
              style={{ transitionDelay: "0.1s" }}
            >
              Egal ob Sie als Einzeltrainer:in starten oder ein ganzes Team
              koordinieren – unsere Plattform passt sich Ihrem Bedarf an.
              Verwalten Sie mehrere Klient:innen, Programme und Standorte
              effizient und professionell.
            </p>
            <p
              className={
                isVisible.about3Text ? "fade-in-up visible" : "fade-in-up"
              }
              style={{ transitionDelay: "0.2s" }}
            >
              Ganz ohne Mehraufwand. So bleibt mehr Zeit für das Wesentliche:
              Ihre Betreuung.
            </p>
          </div>
          <div className="right fade-hidden" ref={about3RightRef}>
            <div className="floating-image">
              <img
                style={{ maxHeight: "300px" }}
                src={require("../img/about-extra-2.svg").default}
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      {/* All in One */}

      <section className="video-section">
        <div className="video-background">
          <video
            ref={videoRef2}
            className="all-video"
            src="/videos/feedback.mp4"
            muted
            playsInline
            style={{
              width: "100%",
              maxHeight: "80vh",
              objectFit: "contain",
              display: "block",
            }}
          />
        </div>
      </section>

      {/* Services */}
      <section className={styles.servicesSection} id="plans">
        <div className={styles.container}>
          <div className={styles.header}>
            <span className={styles.subtitle}>Bestleistungen bringen</span>
            <h2 className={styles.title}>
              Setzen Sie sich Ziele und{" "}
              <span className={styles.floatingText}>elevaten</span> Sie Ihre
              Betreuung.
            </h2>
            <div className={styles.divider} />
          </div>

          <div className={styles.grid}>
            <div
              className={styles.card}
              ref={addToCardRefs}
              style={{
                opacity: 0,
                transform: "translateY(40px)",
                transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
              }}
            >
              <FontAwesomeIcon
                icon={icon({ name: "users" })}
                className={styles.icon}
              />
              <h3 className={styles.title}>Klient:innen gewinnen</h3>
              <p className={styles.description}>
                Klient:innen die Sie noch nicht kennnen, jedoch die App
                heruntergeladen haben können mit Ihnen Kontakt aufnehmen und
                Ihre Expertise nutzen.
              </p>
            </div>

            <div
              className={styles.card}
              ref={addToCardRefs}
              style={{
                opacity: 0,
                transform: "translateY(40px)",
                transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
              }}
            >
              <FontAwesomeIcon
                icon={icon({ name: "laptop" })}
                className={styles.icon}
              />
              <h3 className={styles.title}>Vereinfachen</h3>
              <p className={styles.description}>
                Digitalisieren und Skaliseren Sie ihr Coaching. Ganz ohne
                Papierkram starten Sie in eine effiziente, moderne
                Coaching-Zukunft.
              </p>
            </div>

            <div
              className={styles.card}
              ref={addToCardRefs}
              style={{
                opacity: 0,
                transform: "translateY(40px)",
                transition: "opacity 0.6s ease-out, transform 0.6s ease-out",
              }}
            >
              <FontAwesomeIcon
                icon={icon({ name: "link" })}
                className={styles.icon}
              />
              <h3 className={styles.title}>Klient:innen binden</h3>
              <p className={styles.description}>
                Durch personalisierte Betreuung, moderne App-Funktionen und
                transparente Fortschrittsverfolgung fühlen sich Ihre
                Klient:innen ernst genommen und motiviert.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Statistics */}
      {/* <section className="why" id="statistics">
        <div className="container">
          <h2 style={{ marginBottom: "40px" }}>Statistiken</h2>
          <div className="flex-row write-up">
            <div className="col">
              <i className="fas fa-pencil-alt">
                <FontAwesomeIcon
                  icon={icon({ name: "pencil-alt", style: "solid" })}
                />
              </i>
              <h3>Einheiten</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
            <div className="col">
              <i className="fas fa-signal">
                <FontAwesomeIcon
                  icon={icon({ name: "signal", style: "solid" })}
                />
              </i>
              <h3>Neue Nutzer</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
            <div className="col">
              <i className="fas fa-search">
                <FontAwesomeIcon
                  icon={icon({ name: "search", style: "solid" })}
                />
              </i>
              <h3>Suchen</h3>
              <p>
                Lorem, ipsum dolor sit amet consectetur adipisicing elit. Iusto
                facilis esse eos ad laudantium quaerat quis, dolorum praesentium
                vero consectetur odio eaque ipsa consequatur laborum quas
                voluptate! Sed, eos a.
              </p>
              <span>Mehr</span>
            </div>
          </div>
          <div className="flex-row analytics">
            <div className="col">
              <span className="number">274</span>
              <span className="title">Aktive Nutzer</span>
            </div>
            <div className="col">
              <span className="number">3</span>
              <span className="title">Trainingspläne</span>
            </div>
          </div>
        </div>
      </section> */}

      {/* Contact us */}
      <section
        style={{
          background: "linear-gradient(45deg, #0f172a 0%, #1e293b 100%)",
          position: "relative",
          overflow: "hidden",
        }}
        className="contact-us"
        id="support"
      >
        {/* Animated background elements */}
        <div className="animated-bg-elements">
          <div
            className="bg-circle"
            style={{
              position: "absolute",
              width: "250px",
              height: "250px",
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(139, 92, 246, 0.2) 0%, rgba(139, 92, 246, 0) 70%)",
              top: "20px",
              right: "-50px",
              animation: "float 10s ease-in-out infinite",
            }}
          ></div>
          <div
            className="bg-circle"
            style={{
              position: "absolute",
              width: "200px",
              height: "200px",
              borderRadius: "50%",
              background:
                "radial-gradient(circle, rgba(139, 92, 246, 0.1) 0%, rgba(139, 92, 246, 0) 70%)",
              bottom: "50px",
              left: "100px",
              animation: "float 12s ease-in-out infinite reverse",
            }}
          ></div>
        </div>

        <div className="container">
          <div
            className="contact-card"
            ref={addToCardRefs}
            style={{
              opacity: 0,
              transform: "translateY(40px)",
              transition: "opacity 0.8s ease-out, transform 0.8s ease-out",
              borderRadius: "16px",
              boxShadow: "0 20px 40px rgba(0, 0, 0, 0.2)",
              overflow: "hidden",
              border: "1px solid rgba(255, 255, 255, 0.1)",
              background: "rgba(255, 255, 255, 0.03)",
              backdropFilter: "blur(10px)",
            }}
          >
            <h2
              className="contact-title"
              style={{
                fontSize: "2.2rem",
                marginBottom: "1.5rem",
                background: "linear-gradient(90deg, #fff, #ccc)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                textAlign: "center",
              }}
            >
              Anfragen & loslegen
            </h2>
            <p
              className="contact-desc"
              style={{
                marginBottom: "2rem",
                color: "#ccc",
                lineHeight: 1.6,
                textAlign: "center",
              }}
            >
              Möchten Sie mit uns arbeiten oder haben Sie Fragen? Füllen Sie das
              folgende Formular aus, um loszulegen! <br />
              Oder melden Sie sich direkt{" "}
              <a
                href="mailto:elev8ionhelp@gmail.com"
                className="contact-email"
                style={{
                  color: "var(--color-theme)",
                  textDecoration: "underline",
                  fontWeight: 600,
                  transition: "color 0.3s ease",
                }}
              >
                 hier
              </a>
              {" "}per Mail bei uns.
            </p>
            <form
              className="contact-form"
              onSubmit={(e) => {
                e.preventDefault();
                handleContactFormSubmit();
              }}
            >
              {formSubmitStatus.message && (
                <div
                  className={`form-message ${
                    formSubmitStatus.success ? "success" : "error"
                  }`}
                  style={{
                    padding: "10px",
                    borderRadius: "5px",
                    marginBottom: "15px",
                    textAlign: "center",
                    backgroundColor: formSubmitStatus.success
                      ? "rgba(75, 181, 67, 0.2)"
                      : "rgba(255, 0, 0, 0.1)",
                    color: formSubmitStatus.success ? "#4bb543" : "#ff6b6b",
                  }}
                >
                  {formSubmitStatus.message}
                </div>
              )}
              <div className="form-group">
                <div
                  className="form-row"
                  style={{
                    display: "flex",
                    gap: "15px",
                    marginBottom: "15px",
                  }}
                >
                  <input
                    type="text"
                    className="form-input"
                    placeholder="Name"
                    value={contactFormData.name}
                    onChange={(e) =>
                      setContactFormData({
                        ...contactFormData,
                        name: e.target.value,
                      })
                    }
                    required
                    style={{
                      flex: 1,
                      padding: "15px",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      background: "rgba(255, 255, 255, 0.05)",
                      color: "#fff",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                  />
                  <input
                    type="email"
                    className="form-input"
                    placeholder="E-Mail"
                    value={contactFormData.email}
                    onChange={(e) =>
                      setContactFormData({
                        ...contactFormData,
                        email: e.target.value,
                      })
                    }
                    required
                    style={{
                      flex: 1,
                      padding: "15px",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 255, 255, 0.1)",
                      background: "rgba(255, 255, 255, 0.05)",
                      color: "#fff",
                      transition: "all 0.3s ease",
                      outline: "none",
                    }}
                  />
                </div>
              </div>
              <div className="form-group" style={{ marginBottom: "15px" }}>
                <input
                  type="text"
                  className="form-input"
                  placeholder="Betreff"
                  value={contactFormData.subject}
                  onChange={(e) =>
                    setContactFormData({
                      ...contactFormData,
                      subject: e.target.value,
                    })
                  }
                  required
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: "8px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    background: "rgba(255, 255, 255, 0.05)",
                    color: "#fff",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                />
              </div>
              <div className="form-group" style={{ marginBottom: "25px" }}>
                <textarea
                  className="form-input textarea"
                  placeholder="Ihre Nachricht"
                  rows={4}
                  ref={messageRef}
                  value={contactFormData.message}
                  onChange={(e) =>
                    setContactFormData({
                      ...contactFormData,
                      message: e.target.value,
                    })
                  }
                  required
                  style={{
                    width: "100%",
                    padding: "15px",
                    borderRadius: "8px",
                    border: "1px solid rgba(255, 255, 255, 0.1)",
                    background: "rgba(255, 255, 255, 0.05)",
                    color: "#fff",
                    transition: "all 0.3s ease",
                    outline: "none",
                    resize: "vertical",
                  }}
                ></textarea>
              </div>
              <div style={{ textAlign: "center", width: "100%" }}>
                <button
                  style={{
                    display: "inline-block",
                    marginTop: 0,
                    padding: "15px 40px",
                    borderRadius: "30px",
                    background: "var(--color-theme)",
                    color: "white",
                    fontWeight: "600",
                    border: "none",
                    cursor: isFormSubmitting ? "wait" : "pointer",
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    opacity: isFormSubmitting ? 0.7 : 1,
                    //boxShadow: "0 3px 5px var(--color-theme)"
                  }}
                  className="btn submit-form"
                  type="submit"
                  disabled={isFormSubmitting}
                  onMouseOver={(e) =>
                    !isFormSubmitting &&
                    (e.currentTarget.style.transform = "translateY(-3px)")
                  }
                  onMouseOut={(e) =>
                    !isFormSubmitting &&
                    (e.currentTarget.style.transform = "translateY(0)")
                  }
                >
                  {isFormSubmitting ? "Wird gesendet..." : "Senden"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default Home;
